/** Design: Figma "video thumbnails" — node 25442:15521 (1-8), 25442:15756 (9-12). */
export enum VideoPosterGradeBand {
  LOWER_GRADES = 'lower-grades',
  HIGHER_GRADES = 'higher-grades',
}

/** First grade level that uses the higher-grades background. */
export const HIGHER_GRADES_FIRST_GRADE_LEVEL = 9

/** srcKeys in the assets bucket. */
export const VIDEO_POSTER_BACKGROUND_KEYS: Record<VideoPosterGradeBand, string> = {
  [VideoPosterGradeBand.LOWER_GRADES]: 'videos/thumbnails/bg-video-poster-lower-grades.jpg',
  [VideoPosterGradeBand.HIGHER_GRADES]: 'videos/thumbnails/bg-video-poster-higher-grades.jpg',
}

/** One width for all viewports: a per-URL derivative costs ~1.5s cold vs ~140ms warm, so share one cache entry. */
export const VIDEO_POSTER_WIDTH = 1280

/** Aspect ratio of the design frame (852x479). */
export const VIDEO_POSTER_ASPECT_RATIO = 479 / 852

/** Square size requested for the avatar cut-out. */
export const VIDEO_POSTER_AVATAR_SIZE = 480
